import React from "react";
import { ReactComponent as IconDocumentManager } from "../../assets/images/icon-document-manager.svg";
import { ReactComponent as IconEventManager } from "../../assets/images/icon-events-manager.svg";
import { ReactComponent as IconUiManager } from "../../assets/images/icon-ui-manager.svg";
import { ReactComponent as IconArchiveManager } from "../../assets/images/icon-archive-manager.svg";
import { ReactComponent as IconPlanAutomation } from "../../assets/images/icon-plan-automation.svg";

export interface MenuItem {
  label: string;
  icon: string | React.ReactNode;
  path?: string;
  menuID: string;
  quantity?: string;
  visible?: boolean;
  children?: MenuItem[];
  /** Remote SVG for dynamic AC menus */
  iconSrc?: string | null;
}

export const buildSideMenuItems = (
  t: (key: string) => string,
  authList: string[]
): MenuItem[] => [
  {
    label: t("menu.platformRelatedReports"),
    icon: "icon icon-check",
    menuID: "8",
    visible: authList.includes("view_admin_center_reports"),
    path: "/reports",
  },
  {
    label: t("menu.uam"),
    icon: "icon icon-security",
    menuID: "1",
    visible: authList.includes("operate_uam"),
    children: [
      { label: t("menu.users"), icon: "", path: "/user-access-management/users", visible: authList.includes("operate_users_management"), menuID: "1-1" },
      { label: t("menu.clients"), icon: "", path: "/user-access-management/clients", visible: authList.includes("operate_clients_management"), menuID: "1-2" },
      { label: t("menu.scim"), icon: "", path: "/user-access-management/scim", visible: authList.includes("operate_scim_configuration"), menuID: "1-7" },
      { label: t("menu.roles"), icon: "", path: "/user-access-management/roles", visible: authList.includes("operate_roles_management"), menuID: "1-3" },
      { label: t("menu.userGroups"), icon: "", path: "/user-access-management/user-groups", visible: authList.includes("operate_user_groups_management"), menuID: "1-4" },
      { label: t("menu.accessControl"), icon: "", path: "/user-access-management/acl", visible: authList.includes("operate_access_control_management"), menuID: "1-5" },
      { label: t("menu.distribution"), icon: "", path: "/user-access-management/distribution", visible: authList.includes("operate_distribution_lists_management"), menuID: "1-6" },
    ],
  },
  {
    label: t("menu.cm"),
    icon: "icon icon-settings3",
    menuID: "2",
    visible: authList.includes("operate_cm"),
    children: [
      { label: t("menu.menuManager"), icon: "", path: "/configuration/menu-manager", visible: true, menuID: "2-1" },
      { label: t("menu.wizardManager"), icon: "", path: "/configuration/wizard-manager", visible: true, menuID: "2-4" },
      { label: t("menu.formManager"), icon: "", path: "/configuration/form-manager", visible: true, menuID: "2-2" },
      { label: t("menu.gridManager"), icon: "", path: "/configuration/grid-manager", visible: true, menuID: "2-3" },
    ],
  },
  { label: t("audit.label"), icon: "icon icon-data-viewer", menuID: "3", visible: authList.includes("view_audit"), path: "/audit" },
  { label: t("menu.notifications"), icon: "icon icon-notification", menuID: "4", visible: authList.includes("view_notifications"), path: "/notifications" },
  { label: t("menu.workflowManager"), icon: "icon icon-share", menuID: "5", visible: authList.includes("view_workflow_manager"), path: "/workflow-manager" },
  { label: t("menu.knowledgeManager"), icon: "icon icon-knowledgemanager", menuID: "6", visible: authList.includes("view_knowledge_manager"), path: "/knowledge-manager" },
  {
    label: t("menu.processManager"),
    icon: "icon icon-processmanager",
    menuID: "7",
    visible: authList.includes("view_process_manager"),
    children: [
      { label: t("menu.taskManager"), icon: "", path: "/bpmn/task-manager", visible: authList.includes("operate_task_manager"), menuID: "7-1" },
      { label: t("menu.templateManager"), icon: "", path: "/bpmn/template-manager", visible: authList.includes("operate_template_manager"), menuID: "7-2" },
      { label: t("menu.templateAutoLauncher"), icon: "", path: "/bpmn/auto-launcher", visible: authList.includes("operate_template_auto_launcher"), menuID: "7-3" },
    ],
  },
  { label: t("menu.eventManager"), icon: <IconEventManager />, menuID: "9", visible: authList.includes("operate_event_manager"), path: "/event-manager" },
  { label: t("menu.docsManager"), icon: <IconDocumentManager />, menuID: "10", visible: authList.includes("operate_docs_manager"), path: "/docs-manager" },
  { label: t("menu.uiManager"), icon: <IconUiManager />, menuID: "11", visible: authList.includes("view_ui_manager"), path: "/uimanager" },
  { label: t("menu.archiveManager"), icon: <IconArchiveManager />, menuID: "12", visible: authList.includes("view_archive_manager"), path: "/archivemanager" },
  { label: t("menu.planAndAutomation"), icon: <IconPlanAutomation />, menuID: "13", visible: authList.includes("admin-center-view-plan-and-automation"), path: "/plan-and-automation" },
];

export const flattenMenuItems = (items: MenuItem[]): MenuItem[] => {
  const result: MenuItem[] = [];
  const walk = (list: MenuItem[]) => {
    list.forEach((item) => {
      if (item.visible === false) return;
      if (item.path) result.push(item);
      if (item.children) walk(item.children);
    });
  };
  walk(items);
  return result;
};
